import { MktTopBar, MktTopBarNestableItem } from '@securitize/reactjs-mkt-ui';
import {
  TopBarItemModel,
  TopBarLinkModel,
} from '../../data/builderio/top-bar/top-bar-link.model';
import { Link } from 'react-router-dom';
import secCreditPositive from '@securitize/assets-sec-ui/dist/logos/svg/sec-credit-positive.svg';
import secCreditNegative from '@securitize/assets-sec-ui/dist/logos/svg/sec-credit-negative.svg';

interface TopBarProps {
  topBarLinks: TopBarLinkModel[] | [];
  variant?: 'dark' | 'light' | 'transparent';
  transparentVariant: 'light' | 'dark';
  fixedVariant: 'light' | 'dark' | null;
}

export const TopBar: React.FC<TopBarProps> = ({
  topBarLinks,
  variant = 'dark',
  transparentVariant = 'dark',
  fixedVariant,
}) => {
  const homeItem: MktTopBarNestableItem = topBarLinks
    .filter(({ data }) => data.type === 'home')
    .map(({ data }: TopBarLinkModel, index) => {
      return {
        id: index,
        label: data.label,
        url: data.url,
      };
    })[0];

  const menuItems: MktTopBarNestableItem[] = topBarLinks
    .filter(({ data }) => data.type === 'nav')
    .map(({ data }: TopBarLinkModel, index) => {
      return {
        id: index,
        label: data.label,
        url: data.url,
        subLinks: data.subLinks?.map(
          (subLink: TopBarItemModel, index: number) => {
            return {
              id: index,
              label: subLink.label,
              url: subLink.url,
            };
          },
        ),
      };
    });

  const loginItem: MktTopBarNestableItem = topBarLinks
    .filter(({ data }) => data.type === 'login')
    .map(({ data }: TopBarLinkModel, index) => {
      return {
        id: index,
        label: data.label,
        url: data.url,
      };
    })[0];

  const signUpItem: MktTopBarNestableItem = topBarLinks
    .filter(({ data }) => data.type === 'register')
    .map(({ data }: TopBarLinkModel, index) => {
      return {
        id: index,
        label: data.label,
        url: data.url,
      };
    })[0];

  return (
    <MktTopBar
      homeItem={homeItem}
      menuItems={menuItems}
      loginItem={loginItem}
      signUpItem={signUpItem}
      linkComponent={Link}
      variant={variant}
      transparentVariant={transparentVariant}
      fixedVariant={fixedVariant}
      negativeLogo={secCreditNegative}
      positiveLogo={secCreditPositive}
    />
  );
};
